<template>
  <div class="h5-layout">
    <div class="h5-header">
      <div class="h5-header-back" @click="goBack">‹</div>
      <div class="h5-header-title">{{ title }}</div>
      <div class="h5-header-side"></div>
    </div>
    <div class="h5-body">
      <slot></slot>
    </div>
    <H5Tabbar :active="active"></H5Tabbar>
  </div>
</template>

<script>
import H5Tabbar from "./H5Tabbar.vue";

export default {
  name: "H5Layout",
  components: {H5Tabbar},
  props: {
    title: {type: String, default: ''},
    active: {type: String, default: ''}
  },
  methods: {
    goBack() {
      if (window.history.length > 1) {
        this.$router.back();
      } else {
        this.$router.push('/home_h5');
      }
    }
  }
}
</script>

<style>
/* ============ H5 移动端基础布局（全局，供内部复用组件适配） ============ */
.h5-layout {
  max-width: 640px;
  margin: 0 auto;
  height: 100%;
  min-height: 100vh;
  min-height: 100dvh; /* 动态视口高度，适配底部手势导航 */
  background: #f5f7fa;
  display: flex;
  flex-direction: column;
  overflow-x: hidden;
  -webkit-tap-highlight-color: transparent;
}

.h5-header {
  position: sticky;
  top: 0;
  z-index: 100;
  height: 46px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 12px;
  background: #409eff;
  color: #fff;
  font-size: 16px;
  flex-shrink: 0;
}

.h5-header-back {
  font-size: 26px;
  line-height: 1;
  width: 40px;
  cursor: pointer;
  padding-bottom: 4px;
}

.h5-header-title {
  font-weight: 600;
}

.h5-header-side {
  width: 40px;
}

.h5-body {
  flex: 1;
  padding: 10px;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
}

/* ---------- 复用PC组件在移动端的通用适配 ---------- */

/* ===== 个人信息页 ===== */
.h5-layout .Person-container {
  width: 100% !important;
}

.h5-layout .Person-container .el-form-item__label {
  width: 80px !important;
}

.h5-layout .Person-container .el-form-item__content {
  margin-left: 80px !important;
}

/* ===== 录音识别页：让文本区自动撑满剩余空间、按钮紧跟底部 ===== */
.h5-layout .Meeting-container {
  padding: 0 !important;
  margin-bottom: 0 !important;
  display: flex;
  flex-direction: column;
  min-height: 100%;
}

/* 包裹 textarea 的 div — 不撑满剩余空间，按钮紧跟其下，保证一屏内完整展示 */
.h5-layout .Meeting-container .Meeting-textarea-wrap,
.h5-layout .Meeting-container > div[style*="height: 150px"] {
  height: auto !important;
  flex: 0 0 auto;
  display: flex;
  flex-direction: column;
}

.h5-layout .Meeting-container textarea {
  height: 14vh !important;
  min-height: 80px !important;
  max-height: 14vh !important;
  flex: none;
  padding: 8px !important;
  font-size: 15px;
  margin-top: 0 !important;
  margin-bottom: 0 !important;
  box-sizing: border-box;
}

/* 按钮区 — 允许换行（静音输入框换到第二行时也完整显示），紧凑间距 */
.h5-layout .Meeting-container div[style*="margin-top:240px"],
.h5-layout .Meeting-container div[style*="margin-top:440px"] {
  margin-top: 0 !important;
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  justify-content: center;
  padding: 6px 0 calc(6px + env(safe-area-inset-bottom)) 0;
  flex-shrink: 0;
}

.h5-layout .Meeting-container div[style*="margin-top:240px"] .el-button,
.h5-layout .Meeting-container div[style*="margin-top:440px"] .el-button {
  flex: 1;
  min-width: 0;
  padding: 8px 0;
  margin: 0 !important;
  white-space: nowrap;
  overflow: hidden;
}

.h5-layout .Meeting-container div[style*="margin-top:240px"] .el-button span,
.h5-layout .Meeting-container div[style*="margin-top:440px"] .el-button span {
  font-size: 13px;
  white-space: nowrap;
}

/* H5 主按钮区静音输入框：固定宽度不参与按钮均分 */
.h5-layout .Meeting-container div[style*="margin-top:240px"] .vad-eos-label,
.h5-layout .Meeting-container div[style*="margin-top:440px"] .vad-eos-label {
  flex-shrink: 0 !important;
  font-size: 12px !important;
  margin: 0 2px !important;
}

.h5-layout .Meeting-container div[style*="margin-top:240px"] .vad-eos-input,
.h5-layout .Meeting-container div[style*="margin-top:440px"] .vad-eos-input {
  flex-shrink: 0 !important;
  width: 80px !important;
}

/* 任务栏 */
.h5-layout .Meeting-container .task-bar {
  flex-shrink: 0;
  flex-wrap: nowrap;
  overflow-x: auto;
  padding: 6px 0;
  margin-bottom: 6px;
}

/* 材长行：上传录音 + 材长 + 查看统计 单行展示 */
.h5-layout .Meeting-container .wood-len-row {
  flex-wrap: nowrap !important;
  gap: 6px;
  padding: 4px 0 calc(4px + env(safe-area-inset-bottom)) 0 !important;
}

.h5-layout .Meeting-container .wood-len-row .el-button {
  padding: 8px 6px !important;
  font-size: 12px;
  white-space: nowrap;
}

.h5-layout .Meeting-container .wood-len-row .wood-len-input {
  width: 96px;
}

/* ===== 表格管理页（文件/用户/角色）通用适配 ===== */
.h5-layout .document-container,
.h5-layout .User-container,
.h5-layout .Role-container {
  padding: 0 !important;
}

/* 搜索操作区 */
.h5-layout .document-container .action-bar,
.h5-layout .User-container > div:first-child,
.h5-layout .Role-container > div:first-child {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-bottom: 10px !important;
}

.h5-layout .document-container .action-bar .action-group,
.h5-layout .User-container > div:first-child,
.h5-layout .Role-container > div:first-child {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  width: 100%;
}

.h5-layout .document-container .action-bar .el-input,
.h5-layout .User-container > div:first-child .el-input,
.h5-layout .Role-container > div:first-child .el-input {
  width: 100% !important;
  margin-left: 0 !important;
}

.h5-layout .document-container .action-bar .el-button,
.h5-layout .User-container > div:first-child .el-button,
.h5-layout .Role-container > div:first-child .el-button {
  flex: 1;
  min-width: 70px;
  margin-left: 0 !important;
}

/* 表格横向滚动，不压缩 */
.h5-layout .el-table {
  width: 100%;
  min-width: 700px;
}

.h5-layout .el-table__body-wrapper,
.h5-layout .el-table__header-wrapper {
  overflow-x: auto !important;
}

.h5-layout .el-table .cell {
  white-space: nowrap;
}

/* 操作列按钮变小，防止被挤压 */
.h5-layout .el-table .el-button {
  padding: 6px 8px;
  font-size: 12px;
}

.h5-layout .el-table .el-button--small,
.h5-layout .el-table .el-button--mini {
  padding: 5px 6px;
  font-size: 11px;
}

/* 分页简化 */
.h5-layout .pagination-wrapper,
.h5-layout .pd-10 {
  margin-top: 10px;
  display: flex;
  justify-content: center;
}

.h5-layout .el-pagination {
  flex-wrap: wrap;
  justify-content: center;
}

.h5-layout .el-pagination .el-pagination__sizes,
.h5-layout .el-pagination .el-pagination__jump {
  display: none !important;
}

/* ===== 通用卡片/弹窗 ===== */
.h5-layout .el-card {
  width: 100% !important;
}

.h5-layout .el-dialog {
  width: 90% !important;
}
</style>
